import { For, type JSX } from "solid-js";

import clsx from "~/util/html/style";

import { ArchArt } from "../art/arch_art";
import styles from "../deck.module.css";
import { useDeckWords } from "../deck_words";
import type { CoverSlide as CoverSlideData, Deck } from "../types";

/** The title slide: whose plan it is, from which office, and the whole mouth with the planned teeth lit. */
export function CoverSlide(props: { slide: CoverSlideData; deck: Deck }): JSX.Element {
  const words = useDeckWords();
  return (
    <>
      <div>
        <h2 class={clsx(styles["s-h"], styles["cv-h"])}>{props.slide.headline}</h2>
        <p class={clsx(styles["s-lead"], styles["cv-sub"])}>{props.deck.officeName}</p>
        <ul class={styles["cv-meta"]}>
          <For each={props.slide.chips}>{(chip) => <li class={styles["chip-d"]}>{chip}</li>}</For>
        </ul>
      </div>
      <div class={styles["cv-art"]}>
        <ArchArt
          arch={props.slide.arch}
          mode="dark"
          numbers={false}
          title={words().t("teethInYourPlan")}
        />
      </div>
    </>
  );
}
